import { render, staticRenderFns } from "./Списание за период.vue?vue&type=template&id=9f25c68c&scoped=true&"
import script from "./Списание за период.vue?vue&type=script&lang=js&"
export * from "./Списание за период.vue?vue&type=script&lang=js&"
import style0 from "./Списание за период.vue?vue&type=style&index=0&id=9f25c68c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f25c68c",
  null
  
)

export default component.exports